import { render, staticRenderFns } from "./DataCentreInternetService.vue?vue&type=template&id=3939d16e&"
import script from "./DataCentreInternetService.vue?vue&type=script&lang=js&"
export * from "./DataCentreInternetService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports